/* Petzy Premium — interactions */
(() => {
  const P = window.Petzy || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function formatMoney(cents, format = P.moneyFormat || '${{amount}}') {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    const fmt = (n, d = 2, t = ',', dec = '.') => {
      const parts = (n / 100).toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(dec);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        default: return fmt(cents, 2);
      }
    });
  }
  P.formatMoney = formatMoney;
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const sized = (url, w) => {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  };

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root = document) {
    const els = $$('[data-reveal]:not(.is-in)', root);
    if (!('IntersectionObserver' in window) || reduced) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- Hero ---------- */
  function initHero() {
    $$('.hero').forEach((hero) => {
      const title = $('.hero__title', hero);
      if (title && !title.dataset.split) {
        title.dataset.split = '1';
        let i = 0;
        const walk = (node) => {
          Array.from(node.childNodes).forEach((ch) => {
            if (ch.nodeType === 3) {
              const frag = document.createDocumentFragment();
              ch.textContent.split(/(\s+)/).forEach((part) => {
                if (!part) return;
                if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
                const w = document.createElement('span'); w.className = 'word';
                const inner = document.createElement('span'); inner.style.setProperty('--i', i++); inner.textContent = part;
                w.appendChild(inner); frag.appendChild(w);
              });
              ch.replaceWith(frag);
            } else if (ch.nodeType === 1) walk(ch);
          });
        };
        walk(title);
      }
      requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is-in')));
      setTimeout(() => hero.classList.add('is-settled'), 2200);
    });
  }

  /* ---------- Parallax ---------- */
  function initParallax() {
    if (reduced) return;
    const items = $$('[data-parallax]');
    if (!items.length) return;
    let ticking = false;
    const update = () => {
      const vh = window.innerHeight;
      items.forEach((el) => {
        const r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        const progress = (r.top + r.height / 2 - vh / 2) / vh;
        const amt = parseFloat(el.dataset.parallax) || 40;
        el.style.setProperty('--parallax', (progress * -amt).toFixed(1) + 'px');
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* ---------- Statement word lighting ---------- */
  function initStatement() {
    $$('[data-statement]').forEach((el) => {
      if (!el.dataset.split) {
        el.dataset.split = '1';
        el.innerHTML = el.textContent.trim().split(/\s+/).map((w) => `<span class="w">${esc(w)}</span> `).join('');
      }
      const words = $$('.w', el);
      if (reduced) { words.forEach((w) => w.classList.add('is-lit')); return; }
      const onScroll = () => {
        const r = el.getBoundingClientRect();
        const vh = window.innerHeight;
        const p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
        const n = Math.round(p * words.length);
        words.forEach((w, i) => w.classList.toggle('is-lit', i < n));
      };
      window.addEventListener('scroll', () => requestAnimationFrame(onScroll), { passive: true });
      onScroll();
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const header = $('.site-header');
    if (!header) return;
    let last = window.scrollY;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      const menuOpen = document.documentElement.classList.contains('lock');
      if (!menuOpen) header.classList.toggle('is-hidden', y > last && y > 240);
      last = y;
    }, { passive: true });

    const menu = $('#MobileMenu');
    $$('[data-menu-open]').forEach((b) => b.addEventListener('click', () => { menu.classList.add('is-open'); lock(true); }));
    $$('[data-menu-close]').forEach((b) => b.addEventListener('click', () => { menu.classList.remove('is-open'); lock(false); }));
  }
  function lock(on) { document.documentElement.classList.toggle('lock', on); document.body.style.overflow = on ? 'hidden' : ''; }

  /* ---------- Search ---------- */
  function initSearch() {
    const ov = $('#SearchOverlay');
    if (!ov) return;
    const input = $('[data-predictive-input]', ov);
    const results = $('[data-predictive-results]', ov);
    const open = () => { ov.classList.add('is-open'); ov.setAttribute('aria-hidden', 'false'); lock(true); setTimeout(() => input.focus(), 250); };
    const close = () => { ov.classList.remove('is-open'); ov.setAttribute('aria-hidden', 'true'); lock(false); };
    $$('[data-search-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
    $$('[data-search-close]', ov).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); closeCart(); } });
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${P.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const data = await r.json();
          const items = (data.resources && data.resources.results && data.resources.results.products) || [];
          results.innerHTML = items.length
            ? items.map((p) => `<a class="predict" href="${esc(p.url)}">${p.image ? `<img src="${esc(sized(p.image, 160))}" alt="" loading="lazy">` : ''}<span>${esc(p.title)}<br><strong>${esc(formatMoney(Math.round(parseFloat(p.price) * 100)))}</strong></span></a>`).join('')
            : `<p class="muted">No products found for “${esc(q)}”.</p>`;
        } catch (e) { results.innerHTML = ''; }
      }, 220);
    });
  }

  /* ---------- Cart ---------- */
  const drawer = () => $('#CartDrawer');
  function openCart() { const d = drawer(); if (!d) return; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); lock(true); }
  function closeCart() { const d = drawer(); if (!d || !d.classList.contains('is-open')) return; d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); lock(false); }

  async function getCart() { const r = await fetch(P.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count; el.dataset.count = cart.item_count;
      el.classList.remove('is-bumped'); void el.offsetWidth; el.classList.add('is-bumped');
    });
    const d = drawer();
    if (!d) return;
    const body = $('[data-cart-body]', d);
    const foot = $('[data-cart-foot]', d);
    $('[data-cart-title-count]', d).textContent = cart.item_count ? `(${cart.item_count})` : '';
    if (!cart.item_count) {
      body.innerHTML = `<div class="cart-empty"><h3>Your cart is empty</h3><a href="/collections/all" class="btn">Start shopping <span class="arrow">→</span></a></div>`;
      foot.hidden = true;
      return;
    }
    foot.hidden = false;
    let progress = '';
    const th = Number(P.freeShippingThreshold) || 0;
    if (th > 0) {
      const left = th - cart.total_price;
      const pct = Math.min(100, (cart.total_price / th) * 100);
      progress = `<div class="progress">${left > 0 ? `You're <strong>${formatMoney(left)}</strong> away from free shipping` : `🎉 You've unlocked <strong>free shipping</strong>`}<div class="progress__bar"><span style="width:${pct}%"></span></div></div>`;
    }
    body.innerHTML = progress + cart.items.map((it, idx) => `
      <div class="line" style="animation-delay:${idx * 50}ms" data-line="${idx + 1}">
        <a href="${esc(it.url)}">${it.image ? `<img src="${esc(sized(it.image, 200))}" alt="${esc(it.product_title)}" loading="lazy">` : ''}</a>
        <div>
          <a href="${esc(it.url)}" class="line__title">${esc(it.product_title)}</a>
          ${it.product_has_only_default_variant ? '' : `<div class="line__variant">${esc(it.variant_title)}</div>`}
          <div class="line__bottom">
            <div class="qty">
              <button type="button" data-line-qty="${idx + 1}" data-qty="${it.quantity - 1}" aria-label="Decrease quantity">−</button>
              <input type="number" value="${it.quantity}" min="0" aria-label="Quantity" readonly>
              <button type="button" data-line-qty="${idx + 1}" data-qty="${it.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <div class="price">
              ${it.original_line_price > it.final_line_price ? `<span class="price__compare">${formatMoney(it.original_line_price)}</span>` : ''}
              <span>${formatMoney(it.final_line_price)}</span>
            </div>
          </div>
          <button type="button" class="line__remove" data-line-qty="${idx + 1}" data-qty="0">Remove</button>
        </div>
      </div>`).join('');
    $('[data-cart-total]', d).textContent = formatMoney(cart.total_price);
  }

  async function changeLine(line, quantity) {
    const d = drawer();
    d && d.classList.add('is-busy');
    try {
      const r = await fetch(P.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
      });
      renderCart(await r.json());
    } finally { d && d.classList.remove('is-busy'); }
  }

  async function addToCart(form, btn) {
    btn && btn.classList.add('is-loading');
    try {
      const r = await fetch(P.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      renderCart(await getCart());
      openCart();
    } catch (e) {
      const err = form.querySelector('[data-form-error]');
      if (err) { err.textContent = e.message; err.hidden = false; } else alert(e.message);
    } finally { btn && btn.classList.remove('is-loading'); }
  }

  function initCart() {
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[data-ajax-cart]');
      if (!form || !drawer()) return;
      e.preventDefault();
      addToCart(form, form.querySelector('[type="submit"]'));
    });
    document.addEventListener('click', (e) => {
      const q = e.target.closest('[data-line-qty]');
      if (q) { changeLine(q.dataset.lineQty, q.dataset.qty); return; }
      if (e.target.closest('[data-cart-open]') && drawer()) { e.preventDefault(); openCart(); getCart().then(renderCart); return; }
      if (e.target.closest('[data-cart-close]')) closeCart();
    });
  }

  /* ---------- Product ---------- */
  function initProduct(root) {
    const dataEl = $('[data-product-json]', root);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name="id"]', form);
    const addBtn = $('[data-add-button]', root);
    const addLabel = $('[data-add-label]', root);
    const priceEl = $('[data-price]', root);
    const stockEl = $('[data-stock]', root);
    const stickyPrice = $('[data-sticky-price]');
    const stickyBtn = $('[data-sticky-add]');

    const current = () => $$('fieldset.option', root).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const priceHTML = (v) => {
      let h = `<span>${formatMoney(v.price)}</span>`;
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const pct = Math.round((1 - v.price / v.compare_at_price) * 100);
        h += `<span class="price__compare">${formatMoney(v.compare_at_price)}</span><span class="price__save">Save ${pct}%</span>`;
      }
      return h;
    };

    const markAvailability = (opts) => {
      $$('fieldset.option', root).forEach((fs, idx) => {
        $$('input', fs).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const v = product.variants.find((x) => x.options.every((o, i) => o === test[i]));
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
        const legendVal = $('legend span', fs); if (legendVal) legendVal.textContent = opts[idx] || '';
      });
    };

    const update = () => {
      const opts = current();
      const v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }
      idInput.value = v.id;
      priceEl.innerHTML = priceHTML(v);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (stickyBtn) { stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (stockEl) { stockEl.textContent = v.available ? 'In stock — ships with tracking' : 'Currently sold out'; stockEl.classList.toggle('is-out', !v.available); }
      if (v.featured_media) goToMedia(v.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    $$('fieldset.option input', root).forEach((i) => i.addEventListener('change', update));
    if ($$('fieldset.option', root).length) markAvailability(current());

    // qty
    $$('[data-qty-step]', root).forEach((b) => b.addEventListener('click', () => {
      const inp = $('input[name="quantity"]', root);
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + Number(b.dataset.qtyStep));
    }));

    // gallery
    const main = $('[data-gallery-main]', root);
    const thumbs = $$('[data-gallery-thumb]', root);
    const dots = $$('[data-gallery-dot]', root);
    function goToMedia(mediaId) {
      const slide = main && $(`[data-media-id="${mediaId}"]`, main);
      if (slide) main.scrollTo({ left: slide.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
    }
    if (main) {
      thumbs.forEach((t) => t.addEventListener('click', () => goToMedia(t.dataset.galleryThumb)));
      const setActive = () => {
        const idx = Math.round(main.scrollLeft / main.clientWidth);
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
        dots.forEach((t, i) => t.classList.toggle('is-active', i === idx));
      };
      main.addEventListener('scroll', () => requestAnimationFrame(setActive), { passive: true });
      $$('[data-gallery-nav]', root).forEach((b) => b.addEventListener('click', () => {
        main.scrollBy({ left: main.clientWidth * Number(b.dataset.galleryNav), behavior: reduced ? 'auto' : 'smooth' });
      }));
    }

    // sticky add to cart
    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
      });
      io.observe(addBtn);
      stickyBtn && stickyBtn.addEventListener('click', () => {
        if (drawer()) addToCart(form, stickyBtn); else form.submit();
      });
    }
  }

  /* ---------- Accordion smooth ---------- */
  function initAccordions() {
    if (reduced) return;
    $$('.accordion details').forEach((d) => {
      const summary = $('summary', d);
      const body = $('.accordion__body', d);
      if (!summary || !body) return;
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.open) {
          const h = body.scrollHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.16,1,.3,1)' }).onfinish = () => { d.open = false; };
        } else {
          d.open = true;
          const h = body.scrollHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.16,1,.3,1)' });
        }
      });
    });
  }

  /* ---------- Collection sort ---------- */
  function initSort() {
    $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    }));
  }

  function init() {
    initHeader(); initSearch(); initCart(); initHero(); initReveal(); initParallax();
    initStatement(); initAccordions(); initSort();
    $$('[data-product-section]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => {
    initReveal(e.target); initHero(); initParallax(); initStatement(); initAccordions();
    $$('[data-product-section]', e.target).forEach(initProduct);
  });
})();
